import React, {useState, useContext, useEffect, useRef, useCallback} from 'react';
import HeaderMyhome from '../../components/HeaderMyhome';
import './Myhome.css'
import PageList from './PageList'
import Page from './Page'
import {loadLocalUserData, saveLocalUserData2} from '../../utils/loadAndSaveData'
import api from '../../utils/api'
import config from '../../data/config'
import {
  useParams,
  useLocation,
  useHistory  
} from "react-router-dom";

import { DndProvider} from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import {LoginContext} from '../../components/LoginProvider';
import ajaxLoader from '../../icons/ajax-loader.gif';
import SearchResult from '../../components/SearchResult';

function Myhome(props){
  //** get page */
  const params = useParams()
  let [pathUserid, setPathUserid] = useState(params.pathUserid)
  let [pathTitle, setPathTitle] = useState(params.pathTitle)
  const currentPathTitle = useRef(pathTitle)
  //** userid */
  let {userid, token} = useContext(LoginContext)

  //** load page */
  const [show, setShow] = useState(false)
  const [showShare, setShowShare] = useState(false)
  let [selected, setSelected] = useState(null)
  const [, setServerErrors] = useState(null);
  const [loading, setLoading] = useState(true); // Start with loading to prevent flash of old content
  const [page, setPage] = useState(null);
  const [pageShare, setPageShare] = useState(null);
  const [pageList, setPageList] = useState([]);
  const [defaultPageTitle, setDefaultPageTitle] = useState(null);
  let [memoShown, setMemoShown] = useState(true);
  let [tidy, setTidy] = useState(1);
  const pageCache = useRef({})
  const prevPathTitle = useRef('')
  let history = useHistory();

  const handleClearError = useCallback(() => {
    setServerErrors(null);
    api.removePathTitle(pathUserid)
  }, [pathUserid])

  // Clear pageList immediately when user becomes anonym
  useEffect(() => {
    if (userid === config.defaultUserid) {
      setPageList([]);
      setPage(null);
      setDefaultPageTitle(null);
      // Clear ALL cache when switching to anonym user
      pageCache.current = {};
    }
  }, [userid]);

  useEffect(()=>{
    //2----------------------------
      // Clear saved path titles to prevent page jumping
      if(pathUserid && !pathTitle) {
        api.removePathTitle(pathUserid);
      }
      setServerErrors(null);
      let effectivePathUserid = pathUserid;
      if(!effectivePathUserid){
        if(userid){
          effectivePathUserid = userid
        }else{
          effectivePathUserid = config.defaultUserid
        }
      }
      setPathUserid(effectivePathUserid)
      let effectivePathTitle = pathTitle;
      if(!effectivePathTitle){ 
        // Only load saved path title when accessing root path (no userid in URL)
        if(!pathUserid && effectivePathUserid === userid && userid !== config.defaultUserid){// check the saved pathTitle only in case of non-anonymous owner accessing root
          prevPathTitle.current = api.loadPathTitle(userid)
          if(prevPathTitle.current){ // if there is no prefPathTitle, empty string is returned.
            effectivePathTitle = prevPathTitle.current
            currentPathTitle.current = prevPathTitle.current
          }
        }
        // If still no path title, we'll determine it from user data later
        // For anonymous users, use default config for now
        if(!effectivePathTitle && effectivePathUserid === config.defaultUserid) {
          effectivePathTitle = config.defaultPathTitle; // 'home'
        }
      }
      // When pathTitle exists in URL, respect it and don't override with saved path title  
      currentPathTitle.current = effectivePathTitle
      // Only update pathTitle state if it's actually different to avoid circular dependency
      if(pathTitle !== effectivePathTitle) {
        setPathTitle(effectivePathTitle)
        // Only update URL if we're actually changing from a saved path title (root access)
        // Don't update URL when accessing specific user paths like /whatif
        if(!pathUserid) {
          const newURL = `/${effectivePathUserid}/${effectivePathTitle}`;
          window.history.replaceState({}, '', newURL);
        }
      }
      if(pageCache.current[pathUserid] && pageCache.current[pathUserid][pathTitle] && userid !== config.defaultUserid){
        setPage(pageCache.current[pathUserid][pathTitle])
        setPageList(pageCache.current[pathUserid].pageList)
      }else{
        // in case of owner or anonymous user
        if(userid === effectivePathUserid || effectivePathUserid === config.defaultUserid){
          setLoading(true);
          // For anonymous users, bypass cache and always use fresh default data
          let userData;
          if(effectivePathUserid === config.defaultUserid) {
            // Clear localStorage data for anonymous user to prevent previous user data persistence
            localStorage.removeItem(config.localStorageName);
            userData = loadLocalUserData(effectivePathUserid, effectivePathTitle);
          } else {
            // For authenticated users, if no path title specified, find default page first
            if(!effectivePathTitle) {
              // Load user data without specific page to get pageList and find default
              const tempUserData = loadLocalUserData(effectivePathUserid, null);
              if(tempUserData?.defaultPageTitle) {
                effectivePathTitle = tempUserData.defaultPageTitle;
                // Update URL to reflect the default page
                window.history.replaceState({}, '', `/${effectivePathUserid}/${effectivePathTitle}`);
                setPathTitle(effectivePathTitle);
              } else {
                effectivePathTitle = config.defaultPathTitle;
              }
            }
            userData = loadLocalUserData(effectivePathUserid, effectivePathTitle);
          }
          if(userData?.pageData?.children){
            setServerErrors(null);
            setLoading(false);            
            loadPageCallback(userData, effectivePathTitle)
            if(userid !== config.defaultUserid){ // check if the page is updated or not using ts(timestamp)
              doLoadRemotePage(userData.pageData.ts, effectivePathTitle)
            }
          }else{
            if(userid === config.defaultUserid){
              // For anonym user, initialize with default data
              setLoading(false);
              // Clear localStorage to prevent previous user data persistence
              localStorage.removeItem(config.localStorageName);
              const anonymData = loadLocalUserData(effectivePathUserid, effectivePathTitle)
              if(anonymData && anonymData.pageData){
                loadPageCallback(anonymData, effectivePathTitle)
              }else{
                setServerErrors('notfound_error');
              }           
            }else{ // try to load remote page
              doLoadRemotePage(null, effectivePathTitle)
            }
          }
        }else{ // in case of non-owner
          // Don't try to load remote data for anonymous user
          if(effectivePathUserid !== config.defaultUserid) {
            doLoadRemotePage(null, effectivePathTitle)
          } else {
            // For anonymous user accessing via different path, initialize with default data
            setLoading(false);
            // Clear localStorage to prevent previous user data persistence
            localStorage.removeItem(config.localStorageName);
            const anonymData = loadLocalUserData(effectivePathUserid, effectivePathTitle)
            if(anonymData && anonymData.pageData){
              loadPageCallback(anonymData, effectivePathTitle)
            } else {
              setServerErrors('notfound_error');
            }
          }
        }
      }
    function doLoadRemotePage(ts, expectedPathTitle){
      setLoading(true);
      api.loadRemotePage(pathUserid, pathTitle, token.current, ts).then((response) => {
        if(response.errors && response.errors[0]){
          setServerErrors(response.errors[0]);
          setLoading(false);
          handleClearError()
          history.push('/')
        }else{
          setServerErrors(null);
          setLoading(false);
          
          // MongoDB 응답 구조에 맞게 데이터 변환
          const formattedResponse = {
            pageData: {
              title: response.pageData?.title || pathTitle || response.defaultPageTitle,
              children: response.pageData?.children || [],
              memoShown: response.pageData?.memoShown ?? true,
              ts: response.pageData?.ts || Date.now()
            },
            pageList: Array.from(new Map(
              (response.pageList || []).map(page => [
                page._id || page.key || 'default',
                {
                  path: [page.title],
                  key: page._id || page.key || 'default',
                  title: page.title,
                  order: page.order || 0,
                  default: page.default || false,
                  type: page.type || 'pge',
                  public: page.isPublic || page.public || false
                }
              ])
            ).values()).sort((a, b) => a.order - b.order),
            defaultPageTitle: response.defaultPageTitle || 'My Home',
            message: response.message || 'owner_page',
            userid: response.userid || pathUserid
          };

          // IMPORTANT: Merge with local data BEFORE calling loadPageCallback to prevent UI flashing
          let finalResponse = formattedResponse;
          if(response.message === 'newupdate_msg' || response.message === 'owner_page'){
            // Load current local data to preserve pageList metadata
            const localData = loadLocalUserData(userid, null);
            
            if(localData && localData.pageList) {
              // Merge server pageData with local pageList metadata BEFORE rendering
              finalResponse = {
                ...formattedResponse,
                pageList: localData.pageList // Keep local pageList metadata (public/private, default)
              };
            }
          }
          
          loadPageCallback(finalResponse, expectedPathTitle);
          
          // Save the merged response to localStorage
          if(response.message === 'newupdate_msg' || response.message === 'owner_page'){
            saveLocalUserData2(userid, finalResponse);
          }
        }
      }).catch((e) => {
        console.error('Error loading page:', e);
        setLoading(false);
        handleClearError();
        history.push('/');
      });
    }
    function loadPageCallback(userData, expectedPathTitle = null){
      // Use expectedPathTitle if provided, otherwise use current pathTitle
      const targetTitle = expectedPathTitle || pathTitle;
      
      // Prevent showing intermediate server responses that don't match the expected pathTitle
      // This prevents page flashing when server returns default page before correct page
      if(targetTitle && userData.pageData?.title !== targetTitle && userData.message === 'owner_page') {
        return; // Don't update state with incorrect intermediate page
      }
      
      
      currentPathTitle.current = userData.pageData.title
      setDefaultPageTitle(userData.defaultPageTitle)
      setPage(userData.pageData)
      setPageList([...userData.pageList]) // important: pageList is refreshed
      if(userData.pageShare){
        setPageShare(userData.pageShare)
      } 
      // save to cache----------------------------------
      if(!pageCache.current[pathUserid]){
        pageCache.current[pathUserid] = {}
      }
      pageCache.current[pathUserid][pathTitle] = userData.pageData
      pageCache.current[pathUserid].pageList = userData.pageList
      if(!pageCache.current[pathUserid].closeStates){
        pageCache.current[pathUserid].closeStates = {}
      }
      pageCache.current[pathUserid].closeStates[pathTitle] = keepCloseStates(userData.pageData)
      // save to cache===================================
    }
    //2============================
  }, [pathUserid, pathTitle, userid, token, handleClearError, history])
  //==================================
  //** functions */
  const toggleMemo = ()=>{
    memoShown = !memoShown
    page.memoShown = memoShown
    setMemoShown(page.memoShown)
  }
  const keepCloseStates = (page)=>{
    if(!page){
      return
    }
    const closeStates = []
    if(page.children){
      for(let i = 0, n = page.children.length; i < n ; i++){
        closeStates.push(page.children[i].close)
      }
    }
    return closeStates
  }
  const toggleTidy = ()=>{
    tidy = tidy % 3 + 1
    setTidy(tidy)
    resetRecursiveClose(page, tidy)
  }
  function resetRecursiveClose(node, tidy){
    if(tidy === 1){
      if(pageCache.current[pathUserid] && pageCache.current[pathUserid].closeStates && pageCache.current[pathUserid].closeStates[pathTitle]){
        const initialCloseStates = pageCache.current[pathUserid].closeStates[pathTitle]
        node.close = false
        if(node.children && node.children.length > 0){
          for(let i = 0, n = initialCloseStates.length; i < n; i++){
            node.children[i].close = initialCloseStates[i]
          }
        }
      }
    }else if(tidy === 2){
      node.close = false;
      if(node.children && node.children.length){
        for(let i = 0, n = node.children.length; i < n; i++){
          node.children[i].close = true
        }
      }
    }else if(tidy === 3){
      node.close = true;
    }
  }
  //** auth check */
  const checkAuth = (userid, pathUserid) => {
    return userid === pathUserid
  }
  const handleShowPage = (node)=>()=>{
    if(!checkAuth(userid, pathUserid)){
      alert('auth_error')
      return
    }
    setShow(true)
    if(node.children && node.type === 'pge'){ // page edit from page header (has full page structure)
      node = page
      selected = page
      // Add default property from pageList
      const pageInfo = pageList.find(p => p.title === page.title)
      if(pageInfo) {
        selected.default = pageInfo.default
        selected.public = pageInfo.public
      }
    } else if(node.type === 'pge'){ // page edit from PageList (metadata only)
      // For PageList items, they already have the correct properties
      selected = node
    }
    setSelected(node)
  }

  //** search */
  const initialSearchState = { 
    searchFocusIndex: 0,
    searchFoundCount: null,
  };
  const [searchState, setSearchState] = useState(
    initialSearchState
    );
  const{ 
    searchFocusIndex,
    // searchFoundCount,
  } = searchState;
  const [searchResult, setSearchResult] = useState([]);
  const scrollto = (node) => (e) => {
    recursiveOpenParentNode(node, true);
    setPage({...page});
  }

  const resetRecursive = (node) => {
    node.close = true;
    delete node.match;
    if(node.children && node.children.length){
      for(let i = 0, n = node.children.length; i < n; i++){
        node.children[i].path = [...node.path, node.children[i].key];// prepared to open all parentNode upto matched node.
        resetRecursive(node.children[i]);
      }
    }
  }
  const resetSearchResult = () => {
    page.path = [page.title];
    resetRecursive(page);
    page.close = false;// lets open page as default
    setSearchResult([]);
    setSearchState({
      searchFoundCount: 0,
      searchFocusIndex: 0,
    })
  }
  const setSearchString = (searchWord) => {
    resetSearchResult();
    if(!searchWord){
      return;
    }
    const searchWordLower = searchWord.toLowerCase();
    let matches = [];
    let matchesRef = [];
    let matchesIndex = 1;// important since node.match? shows true;
    const foundInTitle = (node) => {
      return node.title.toLowerCase().indexOf(searchWordLower) > -1;
    }
    const foundInHref = (node) => {
      return node.href && (node.href.toLowerCase().indexOf(searchWordLower) > -1);
    }
    const foundInMemo = (node) => {
      return node.memo && (node.memo.toLowerCase().indexOf(searchWordLower) > -1);
    }
    const foundInKeywords = (node) => {
      return node.keywords && (node.keywords.includes(searchWordLower));
    }
    const doSearch = (node) => {
      if(foundInTitle(node) || foundInHref(node) || foundInMemo(node) || foundInKeywords(node)){
        node.match = matchesIndex;
        matches[node.match] = node;
        matchesRef[node.match] = React.createRef();
        matchesIndex++;
      }
      if(node.children && node.children.length){
        for(let i = 0, n = node.children.length; i < n; i++ ){
          doSearch(node.children[i]);
        }
      }
    }
    doSearch(page);
    setSearchResult(matches);
    // setSearchResultRef(matchesRef);
    setSearchState({
      searchFoundCount: matches.length,
      searchFocusIndex:
        matches.length > 0 ? searchFocusIndex % matches.length : 0,
    })
    // doRecursiveOpenParentNode(matches, true);

  }
  const recursiveOpenParentNode = (node, open) => {
    if(node && node.path){
      let parentNode = page;
      parentNode.close = !open;
      for(let i = 1, n = node.path.length - 1; i < n; i++){
        if(parentNode.children && parentNode.children.length){
          parentNode = parentNode.children.find(node2 => node2.key === node.path[i]);
          parentNode.close = !open;
        }
      }
    }
  }
  //********** */
  //** style */
  let style
  if(page && page.bgurl){
    style = {backgroundImage: `url(${page.bgurl})`, backgroundSize:'contain', backgroundRepeat: 'no-repeat', minHeight: '350vh'}
  }
  //** props */
  const HeaderMyhomeProps = {userid, pathUserid, page, pageList, setPageList, toggleMemo, memoShown, setSearchString, resetSearchResult, toggleTidy, tidy, pageCache, checkAuth, token }
  const shareProps = {show, setShow, showShare, setShowShare, selected, setSelected, page: pageShare, setPage: setPageShare, userid, pathUserid, pathTitle, pageList, setPageList, useQuery, setServerErrors, setLoading, 
    checkAuth, defaultPageTitle, currentPathTitle, prevPathTitle, token}
  const pageProps = {show, setShow, showShare, setShowShare, selected, setSelected, page, setPage, userid, pathUserid, pathTitle, pageList, setPageList, useQuery, setServerErrors, setLoading, 
    checkAuth, defaultPageTitle, currentPathTitle, prevPathTitle, token, pageCache}
  const pageListProps = { userid, pageList, pathUserid, pathTitle, handleShowPage, defaultPageTitle, currentPathTitle, setPathUserid, setPathTitle}
  const SearchResultProps = {searchResult, resetSearchResult, scrollto}

  return(
    <>
      {memoShown && <link rel="stylesheet" type="text/css" href={"/vendor/memoShown.css"} />}
      {loading && <img className='ajaxLoader' src={ajaxLoader} alt='ajaxLoader'/>}
      {page && pageList &&
      <div style={style}>
        <HeaderMyhome {...HeaderMyhomeProps}/>
        {tidy !== 3 &&
          <>
            <PageList {...pageListProps}/>
          <DndProvider backend={HTML5Backend}>
            {(pathUserid === config.shareUserid) && pageShare && <Page {...shareProps}/>} 
            <Page {...pageProps}/>
          </DndProvider>
          <div className="container SearchResult">
            <SearchResult {...SearchResultProps}/>
          </div>
          </>
        }     
      </div> 
    }
    </>
  );
}
function useQuery() {
  return new URLSearchParams(useLocation().search)
}
export default Myhome;